import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic as Mi } from "../../../styles";
import { UamType } from '../enum';
import { UAM_STYLES } from '../constants';
export const StyledBlockUamGrid = styled(Grid)(({ type }) => `
	border: ${type === UamType.CONFIRM
    ? Mi.blockConfirmBorder
    : type === UamType.INSTRUCT
        ? Mi.blockInstructBorder
        : `${Mi.baseBorderWidth} ${Mi.baseBorderStyle} ${UAM_STYLES.get(type).color}`};
	color: ${type === UamType.CONFIRM
    ? Mi.baseFontColor
    : type === UamType.INSTRUCT
        ? Mi.baseFontColor
        : UAM_STYLES.get(type).color};
	background-color: ${type === UamType.CONFIRM
    ? Mi.blockConfirmBackgroundColor
    : type === UamType.INSTRUCT
        ? Mi.blockInstructBackgroundColor
        : UAM_STYLES.get(type).background};
	flex-shrink: 0;
	font-family: ${Mi.baseFontFamily};
	padding: ${Mi.blockBasePadding};
	font-size: ${Mi.blockBaseFontSize};
	border-radius: ${Mi.blockBaseBorderRadius};
`);
export const StyledIcon = styled('div')(({ type, isLarge }) => `
    display: flex;
	flex: 0 0 auto;
    align-self: ${isLarge ? 'flex-start' : 'center'};
	font-size: ${isLarge ? Mi.blockUamIconFontSize : Mi.blockSmallUamIconFontSize};
	color: ${UAM_STYLES.get(type).color};
	margin-right: ${Mi.spacer16};
`);
export const StyledBlockTitle = styled('div') `
	line-height: 1;
	font-size: ${Mi.fontSize16};
	font-weight: ${Mi.fontWeightSemibold};
	margin-bottom: ${Mi.spacer08};
`;
export const StyledBlockUamContentDiv = styled('div') `
	flex: 1 1 auto;
	margin-right: 1rem;
	white-space: normal;
	flex-wrap: wrap;
`;
export const StyledCloseButton = styled('div')((props) => `
	flex: 0 0 auto;
    line-height: 1;
    align-self: ${props.isLarge ? 'flex-start' : 'center'};

    .mi-icon-close {
        font-size: ${Mi.buttonCloseFontSize};
        color: ${Mi.buttonCloseColor};
        
        &:hover {
            color: ${Mi.buttonCloseColorHover};
        }
    }
`);
//# sourceMappingURL=Block.style.js.map